import * as yup from 'yup'

const schema = yup.object().shape({
  descricao: yup.string().required('Descrição do Lote é obrigatório'),
  regime: yup.string().nullable().typeError('Regime é obrigatório')
})

export default schema
